import React, { useEffect } from 'react'
import { IModalSMS, IModalSMSContainer } from './modalSMS.type'
import ModalSMS from './modalSMS'
import { useInput } from '../../../hooks/useInput'


const ModalSMSContainer = ({isOpen, handlerButtonCancel, handlerButtonOk, handlerButtonRepeat}: IModalSMSContainer) => {
    const timerValue = useInput<number>(60)
    const disabledRepeatBtn = useInput<boolean>(true)

    const txtNum = useInput<string>('')

    useEffect(() => {
        let timer: any

        if (isOpen) {
            timer = setInterval(() => {
                timerValue.setValue(prevSeconds => {
                    if (prevSeconds === 1) {
                        clearInterval(timer)
                        disabledRepeatBtn.setValue(false)
                        return 60
                    } else {
                        return prevSeconds - 1
                    }
                })
            }, 1000); // Каждую секунду
        }

        return (() => {
            clearInterval(timer)
            timerValue.setValue(60)
            disabledRepeatBtn.setValue(true)

            txtNum.setValue('')
        })
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps


    /** Кнопка отправки повторного СМС */
    const onClickBtnRepeat = () => {
        disabledRepeatBtn.setValue(true)
        handlerButtonRepeat && handlerButtonRepeat()
    }

    /** Свойства передаваемые в компоненту */
    const propsToComponent: IModalSMS = {
        isOpen, handlerButtonCancel, handlerButtonOk, handlerButtonRepeat: onClickBtnRepeat,
        timerValue, disabledRepeatBtn, txtNum
    }

    return <ModalSMS {...propsToComponent} />
}

export default ModalSMSContainer